<template>
  <div class="page-footer">
    <div class="footer-tip-img">
      <img :src="footimg ? footimg.imgurl :defultFootImg" />
    </div>

    <ul class="footer-xy clearfix" id="ul-footer-nav">
      <template v-if="footnav && footnav.length > 0">
        <template v-for="(item,zindex) in footnav">
          <li
            :key="item.id"
            :style="{float:'left', marginRight: (zindex === 0) ? 0 : '50px'}"
            v-if="String(item.state) === '1'"
          >
            <dl>
              <dt>{{ item.name }}</dt>
              <template v-for="fItem in footnav">
                <dd
                  :key="fItem.id"
                  v-if="String(fItem.field) === String(item.id)"
                  @click="toNextPage(fItem)"
                >{{ fItem.name }}</dd>
              </template>
            </dl>
          </li>
        </template>
      </template>

      <li style="float:right;">
        <div style="width:120px;height:120px;margin-top:15px;border:1px solid #e0e0e0;">
          <img style="width:100%;height:100%;" src="../../assets/imgs/wx-qr.jpg" />
        </div>
      </li>
      <li style="float:right;margin-right: 100px;">
        <dl>
          <dt style="font-size:16px;color:#444444;">
            <i class="iconfont icon-message-fill" style="color:#00a3ff;"></i>
            4008-818-101
          </dt>
          <dd style="color:#444444;">
            <i class="iconfont icon-message-fill" style="color:#ffffff;"></i>
            &nbsp;传真025-52101342
          </dd>
          <!-- <dt style="font-size:16px;color:#444444;margin-top: 20px;">
            <i class="iconfont icon-time-circle-fill" style="color:#00a3ff;"></i>
            工作时间
          </dt>
          <dd style="color:#444444;">
            <i class="iconfont icon-time-circle-fill" style="color:#ffffff;"></i>
            &nbsp;周一到周五&nbsp;&nbsp;8:30-17:30
          </dd> -->
        </dl>
      </li>
    </ul>

    <div
      style="background:#2e323e;padding: 20px 0;text-align:center;color:#656668;font-size: 12px;line-height: 25px;"
    >
      <div>Copyright© 2012 - 2018版权所有 南京KERUN信息科技有限公司 ICP备案：苏ICP备19853237号</div>
      <div style="width: 1190px;margin: 0 auto;cursor: pointer;" id="div-footer-link">
        友情链接:
        <template v-if="friendlinks && friendlinks.length > 0">
          <span v-for="item in friendlinks" :key="item.id" @click="toNextPage(item)">{{ item.name }}</span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import defultFootImg from '../../assets/imgs/xx1.png'
export default {
  name: 'PageFooter',
  data () {
    return {
      defultFootImg: defultFootImg,
      footimg: null,
      footnav: null,
      friendlinks: null,
    }
  },
  computed: {
    mainData () {
      return this.$store.getters.maindata
    }
  },
  methods: {
    toNextPage (item) {
      if (item && item.url) {
        window.location.href = item.url
      }
    }
  },
  watch: {
    mainData () {
      const _that = this
      if (this.mainData && this.mainData.rows && this.mainData.rows.length > 0) {
        this.mainData.rows.map(function (item) {
          if (item.levtype === 'footimg') {
            if (item.children && item.children.length > 0) {
              _that.footimg = item.children[0]
            }
          } else if (item.levtype === 'friendlink') {
            if (item.children && item.children.length > 0) {
              _that.friendlinks = item.children
            }
          } else if (item.levtype === 'footnav') {
            if (item.children && item.children.length > 0) {
              _that.footnav = item.children
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page-footer {
  min-width: 1190px;
  width: auto;
  position: relative !important;
  background: #ffffff;
  z-index: 99;
  .footer-tip-img {
    width: 1190px;
    height: 140px;
    line-height: 140px;
    margin: 0 auto;
    border-bottom: 1px solid #e0e0e0;
    img {
      width: 100%;
      height: 50px;
    }
  }
  .footer-xy {
    width: 1190px;
    margin: 0 auto;
    padding: 20px 0;
    dt {
      cursor: pointer;
      line-height: 40px;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
    }
    dd {
      cursor: pointer;
      line-height: 20px;
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>